var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var stream = require('readable-stream');

var nextEvent = require('next-event');

var Box = require('mp4-box-encoding');

var EMPTY = Buffer.alloc(0);

var Decoder = /*#__PURE__*/function (_stream$Writable) {
  "use strict";

  _inherits(Decoder, _stream$Writable);

  function Decoder(opts) {
    var _this;

    _classCallCheck(this, Decoder);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Decoder).call(this, opts));
    _this.destroyed = false;
    _this._pending = 0;
    _this._missing = 0;
    _this._ignoreEmpty = false;
    _this._buf = null;
    _this._str = null;
    _this._cb = null;
    _this._ondrain = null;
    _this._writeBuffer = null;
    _this._writeCb = null;
    _this._ondrain = null;

    _this._kick();

    return _this;
  }

  _createClass(Decoder, [{
    key: "destroy",
    value: function destroy(err) {
      if (this.destroyed) return;
      this.destroyed = true;
      if (err) this.emit('error', err);
      this.emit('close');
    }
  }, {
    key: "_write",
    value: function _write(data, enc, next) {
      if (this.destroyed) return;
      var drained = !this._str || !this._str._writableState.needDrain;

      while (data.length && !this.destroyed) {
        if (!this._missing && !this._ignoreEmpty) {
          this._writeBuffer = data;
          this._writeCb = next;
          return;
        }

        var consumed = data.length < this._missing ? data.length : this._missing;
        if (this._buf) data.copy(this._buf, this._buf.length - this._missing);else if (this._str) drained = this._str.write(consumed === data.length ? data : data.slice(0, consumed));
        this._missing -= consumed;

        if (!this._missing) {
          var buf = this._buf;
          var cb = this._cb;
          var stream = this._str;
          this._buf = this._cb = this._str = this._ondrain = null;
          drained = true;
          this._ignoreEmpty = false;
          if (stream) stream.end();
          if (cb) cb(buf);
        }

        data = consumed === data.length ? EMPTY : data.slice(consumed);
      }

      if (this._pending && !this._missing) {
        this._writeBuffer = data;
        this._writeCb = next;
        return;
      }

      if (drained) next();else this._ondrain(next);
    }
  }, {
    key: "_buffer",
    value: function _buffer(size, cb) {
      this._missing = size;
      this._buf = Buffer.alloc(size);
      this._cb = cb;
    }
  }, {
    key: "_stream",
    value: function _stream(size, cb) {
      var _this2 = this;

      this._missing = size;
      this._str = new MediaData(this);
      this._ondrain = nextEvent(this._str, 'drain');
      this._pending++;

      this._str.on('end', function () {
        _this2._pending--;

        _this2._kick();
      });

      this._cb = cb;
      return this._str;
    }
  }, {
    key: "_readBox",
    value: function _readBox() {
      var _this3 = this;

      var bufferHeaders = function bufferHeaders(len, buf) {
        _this3._buffer(len, function (additionalBuf) {
          if (buf) {
            buf = Buffer.concat([buf, additionalBuf]);
          } else {
            buf = additionalBuf;
          }

          var headers = Box.readHeaders(buf);

          if (typeof headers === 'number') {
            bufferHeaders(headers - buf.length, buf);
          } else {
            _this3._pending++;
            _this3._headers = headers;

            _this3.emit('box', headers);
          }
        });
      };

      bufferHeaders(8);
    }
  }, {
    key: "stream",
    value: function stream() {
      if (!this._headers) throw new Error('this function can only be called once after \'box\' is emitted');
      var headers = this._headers;
      this._headers = null;
      return this._stream(headers.contentLen, null);
    }
  }, {
    key: "decode",
    value: function decode(cb) {
      var _this4 = this;

      if (!this._headers) throw new Error('this function can only be called once after \'box\' is emitted');
      var headers = this._headers;
      this._headers = null;

      this._buffer(headers.contentLen, function (buf) {
        var box = Box.decodeWithoutHeaders(headers, buf);
        cb(box);
        _this4._pending--;

        _this4._kick();
      });
    }
  }, {
    key: "ignore",
    value: function ignore() {
      var _this5 = this;

      if (!this._headers) throw new Error('this function can only be called once after \'box\' is emitted');
      var headers = this._headers;
      this._headers = null;
      this._missing = headers.contentLen;

      if (this._missing === 0) {
        this._ignoreEmpty = true;
      }

      this._cb = function () {
        _this5._pending--;

        _this5._kick();
      };
    }
  }, {
    key: "_kick",
    value: function _kick() {
      if (this._pending) return;
      if (!this._buf && !this._str) this._readBox();

      if (this._writeBuffer) {
        var next = this._writeCb;
        var buffer = this._writeBuffer;
        this._writeBuffer = null;
        this._writeCb = null;

        this._write(buffer, null, next);
      }
    }
  }]);

  return Decoder;
}(stream.Writable);

var MediaData = /*#__PURE__*/function (_stream$PassThrough) {
  "use strict";

  _inherits(MediaData, _stream$PassThrough);

  function MediaData(parent) {
    var _this6;

    _classCallCheck(this, MediaData);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(MediaData).call(this));
    _this6._parent = parent;
    _this6.destroyed = false;
    return _this6;
  }

  _createClass(MediaData, [{
    key: "destroy",
    value: function destroy(err) {
      if (this.destroyed) return;
      this.destroyed = true;

      this._parent.destroy(err);

      if (err) this.emit('error', err);
      this.emit('close');
    }
  }]);

  return MediaData;
}(stream.PassThrough);

module.exports = Decoder;